module.exports = __webpack_public_path__ + "static/media/img.arrow.8d3a1e6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/AppStore/AppManage/AppBatchSetPower/UI.Head/img.arrow.svg
// module id = 6687
// module chunks = 0